// src/components/Login.tsx
import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';

interface LoginProps {
  onLoginSuccess: () => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  const [inputKey, setInputKey] = useState('');
  const [error, setError] = useState('');

  const secretKey = process.env.REACT_APP_SECRET_KEY;

  const handleSubmit = () => {
    if (inputKey === secretKey) {
      setError('');
      onLoginSuccess();
    } else {
      setError('Incorrect secret key');
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      maxWidth={300}
      margin="auto"
      mt={10}
      p={3}
      border="1px solid #ccc"
      borderRadius={2}
    >
      <Typography variant="h6" mb={2}>
        Please enter the secret key
      </Typography>
      <TextField
        label="Secret Key"
        type="password"
        value={inputKey}
        onChange={(e) => setInputKey(e.target.value)}
        error={!!error}
        helperText={error}
        autoFocus
      />
      <Button variant="contained" onClick={handleSubmit} sx={{ mt: 2 }}>
        Login
      </Button>
    </Box>
  );
};

export default Login;
